"use client";

import { useEffect } from 'react';
import { toast } from 'react-hot-toast';

declare global {
  interface Window {
    workbox?: any;
  }
}

export default function PWARegister() {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    // Strict check for production environment
    const isProduction = process.env.NODE_ENV === 'production' && window.location.hostname !== 'localhost';

    if ('serviceWorker' in navigator) {
      if (!isProduction) {
        // DEV MODE: Aggressively unregister all workers
        navigator.serviceWorker.getRegistrations().then((registrations) => {
          if (registrations.length > 0) {
            console.log('🚧 Dev Mode: Unregistering Service Workers to fix caching...');
            let hasUnregistered = false;
            const promises = registrations.map(r => r.unregister().then(success => {
              if (success) hasUnregistered = true;
            }));

            Promise.all(promises).then(() => {
              if (hasUnregistered && navigator.serviceWorker.controller) {
                // Only reload if we actually removed a SW that was controlling the page
                console.log('🔄 Reloading to clear service worker control...');
                window.location.reload();
              }
            });
          }
        });
        return;
      }

      // PROD MODE: Register Service Worker
      navigator.serviceWorker
        .register('/sw.js')
        .then((registration) => {
          console.log('✅ Service Worker registered');

          setInterval(() => {
            registration.update();
          }, 60 * 60 * 1000);

          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  // New version available - Prompt user with a nice toast
                  toast((t) => (
                    <div className="flex items-center gap-3">
                      <div className="flex-1">
                        <p className="font-semibold text-sm">New version available!</p>
                        <p className="text-xs text-gray-500">Refresh to update properly.</p>
                      </div>
                      <button
                        className="bg-primary text-primary-foreground px-3 py-1.5 rounded-md text-xs font-medium hover:opacity-90 transition-opacity"
                        onClick={() => {
                          newWorker.postMessage({ type: 'SKIP_WAITING' });
                          toast.dismiss(t.id);
                          window.location.reload();
                        }}
                      >
                        Update
                      </button>
                    </div>
                  ), {
                    duration: Infinity, // Keep it visible until action
                    position: 'bottom-center',
                    style: {
                      minWidth: '300px',
                    },
                  });
                }
              });
            }
          });
        })
        .catch((err) => console.error('SW Register failed:', err));

      navigator.serviceWorker.addEventListener('controllerchange', () => {
        window.location.reload();
      });
    }
  }, []);

  return null;
}
